/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getSupplierCompanySlugs } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetSupplierCompanySlugs(options?: UseQueryOptions) {
  return useQuery({
    queryKey: userQueryKeys.supplierCompanySlugs,
    queryFn: () => getSupplierCompanySlugs().then((res) => res.data),
    ...options,
  });
}
